import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import getHeadersformdata from './getHeaderFormdata'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { notify } from '../services/notification'
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus'

//Query_list
export const querylistAction = (page, param, fromDate, toDate, persona, categoryId, assignedTo, searchBy, searchValue) => async (dispatch) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}${Url.GET_QUERY}?page=${page}&page_size=10`;
    let url = baseUrl;

    const queryParams = {
      status: param,
      from_date: fromDate,
      to_date: toDate,
      user_type: persona,
      category_id: categoryId,
      assigned_to: assignedTo,
    };

    if (searchBy && searchValue) {
      queryParams[searchBy] = searchValue;
    }

    Object.entries(queryParams).forEach(([key, value]) => {
      if (value) {
        url += `&${key}=${value}`;
      }
    });

    const options = {
      method: 'GET',
      headers: getHeaders(),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_QUERY_LIST, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

//Query Category List
export const queryCategorylistAction = (userType) => async (dispatch) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}${Url.GET_QUERY_CATEGORY}`;
    let url = baseUrl;
    if (userType) {
      url += `?user_type=${userType}`;
    }

    const options = {
      method: 'GET',
      headers: getHeaders(),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {

      dispatch({ type: types.GET_QUERY_LIST, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

//Assignee List
export const assigneeListAction = () => async (dispatch) => {
  try {
    const baseUrl = `${process.env.REACT_APP_API_URL}${Url.GET_ASSIGNEE_LIST}`;
    let url = baseUrl;

    const options = {
      method: 'GET',
      headers: getHeaders(),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_ASSIGNEE_LIST, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

//Assign Query
export const assignQueryAction = (assignToId, queryId) => async (dispatch) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}${Url.ASSIGN_QUERY}`;
    const requestBody = {
      assign_to_id: Number(assignToId),
      query_id: Number(queryId),
    };

    const options = {
      method: 'POST',
      headers: getHeaders(),
      data: JSON.stringify(requestBody),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.ASSIGN_QUERY, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};

//Query_detail
export const querydetailAction = (parm) => dispatch => {
  const url = `${process.env.REACT_APP_API_URL}${Url.GET_QUERY_DETAIL}?check_unique_id=${parm}`;
  let options = Object.assign({ method: 'GET' })
  options.headers = getHeaders()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_QUERY_DETAIL_LIST, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === 400) {
      const errorMessage = error?.response?.data?.error;
      if (errorMessage) {
        if (!notify.error._called) { // Prevent duplicate calls
          notify.error(errorMessage);
          notify.error._called = true; // Track that error has been shown
        }
      } else {
        errorHandler(error);
      }
    }
  })
}

//Query_list
export const querylist3wAction = (page, param, fromDate, toDate, categoryId, pgm_name, pgm_mobile_number, ticket_id, filterByState, filterByValue) => async (dispatch) => {
  try {    
    const baseUrl = `${process.env.REACT_APP_API_URL}${Url.GET_QUERY3W}?page=${page}&page_size=10`;
    let url = baseUrl;   

    const queryParams = {
      query_status: param,
      category_id: categoryId,
      pgm_name,
      pgm_mobile_number,
      ticket_id,
      sort_type: filterByState,
      sort_value: filterByValue,
    };
    if( fromDate && toDate){
      queryParams.from_date= fromDate;
      queryParams.to_date= toDate;
    }
    
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value) {
        url += `&${key}=${value}`;
      }
    });

    const options = {
      method: 'GET',
      headers: getHeaders(),
      url: url,
    };

    const resp = await axios(options);

    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.GET_QUERY_LIST3W, payload: resp });
      return resp;
    } else {
      return null;
    }
  } catch (error) {
    errorHandler(error);
    return null;
  }
};


//  Search Query data
export const searchQueryAction = (params = {}) => dispatch => {
  dispatch({ type: types.SEARCH_QUERY, payload: params ? { data: params } : null })
}

// Query page data
export const pageQueryAction = (params = {}) => dispatch => {
  dispatch({ type: types.PAGE_QUERY, payload: params ?  params  : null })
}

//Query_solution
export const postqueryAction = (params = {}) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.POST_QUERY_SOLUTION

  let options = Object.assign({ method: 'PUT' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()
  options.url = url
  return axios(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_QUERY_SOLUTION, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}  

//add query comment
export const addQueryCommentAction = (comment, queryId) => async (dispatch) => {
  try {
    const url = process.env.REACT_APP_API_URL + Url.ADD_QUERY_COMMENT;
    const requestBody = {
      support_query_id: Number(queryId), // Ensuring it's sent as a number
      comment: comment,
    };

    const options = {
      method: "POST",
      headers: getHeaders(),
      data: JSON.stringify(requestBody),
      url: url,
    };

    const response = await axios(options);

    if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
      dispatch({
        type: types.ADD_QUERY_COMMENT,
        payload: response.data,
      });
      notify.success("Comment added successfully!");
      return response;
    } else {
      notify.error("Failed to add comment.");
      return null;
    }
  } catch (error) {
    notify.error(error?.response.data.errors[0]);
    return null;
  }
};
